import { Component, Input } from '@angular/core';
import { SummaryAll } from '../../models/ai-model';

import { AiService } from '../../services/ai.service';
import { FormsModule } from '@angular/forms';
import { marked } from 'marked';
import TurndownService from 'turndown';
import { SharedModule } from '../../shared/shared.module';
import { ErrorPanelService } from '../../services/error-panel.service';

@Component({
  selector: 'app-ai-summary-all',
  standalone: true,
  imports: [FormsModule, SharedModule],
  templateUrl: './ai-summary-all.component.html',
  styleUrl: './ai-summary-all.component.scss',
})
export class AiSummaryAllComponent {
  @Input() summaryAll: SummaryAll = {
    last_generation_date: '',
    last_generation_time: '',
    html: '',
  };
  @Input() patientId: string = '';
  @Input() isEditing: boolean = false;
  @Input() isLoading: boolean = true;

  markdownContent: string = '';
  private turndownService = new TurndownService();

  constructor(
    private aiService: AiService,
    private errorPanelService: ErrorPanelService
  ) {}

  ngOnChanges() {
    if (this.isEditing) {
      this.markdownContent = this.turndownService.turndown(
        this.summaryAll.html
      );
    } else if (this.markdownContent) {
      const htmlContent = marked.parse(this.markdownContent) as string;
      this.summaryAll.html = htmlContent;
      this.updateSummary(htmlContent);
    }
  }

  onMarkdownChange(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    this.markdownContent = textarea.value;
  }

  private updateSummary(htmlContent: string) {
    if (!this.patientId) return;

    this.aiService.updatePatSumm(this.patientId, htmlContent).subscribe({
      next: () => console.log('Summary updated successfully'),
      error: (error) => {
        console.error('Error updating summary:', error);
        this.errorPanelService.showErrorSnackBar(
          "Errore nell'aggiornare il riassunto"
        );
      },
    });
  }
}
